import { SEA_SITE_CONTEXT } from "@/helpers/jobs";
import { ReactElement } from "react";

export const renderBadge = (
  condition: boolean,
  Component: React.ElementType,
  text: string,
) =>
  condition && (
    <div className="bg-decorative-surface-06 flex items-center gap-[6px] rounded px-2 py-1">
      <Component height={16} width={16} fill="#2BA682" />
      <span className="w-max text-xs font-normal text-green-800">{text}</span>
    </div>
  );

export const getFormattedFreshness = (freshness: number) => {
  if (!freshness || freshness <= 0) {
    return "";
  }

  const currentTime = new Date();
  const targetTime = new Date(freshness);

  let months = (currentTime.getFullYear() - targetTime.getFullYear()) * 12;
  months -= targetTime.getMonth();
  months += currentTime.getMonth();

  const timeDifference = currentTime.getTime() - targetTime.getTime();
  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (currentTime.getDate() < targetTime.getDate()) {
    months--;
  }

  if (months > 0) return months === 1 ? "a month ago" : months + " months ago";
  if (days > 0) return days === 1 ? "a day ago" : days + " days ago";
  if (hours > 0) return hours === 1 ? "an hour ago" : hours + " hours ago";
  if (minutes > 0)
    return minutes === 1 ? "a minute ago" : minutes + " minutes ago";

  return "";
};

export const getApplicantCountText = (total: number) => {
  if (total < 10) return "Be among the first 10 applicants";
  else if (total < 20) return "Be among the first 20 applicants";
  else if (total < 30) return "Be among the first 30 applicants";
  else if (total < 40) return "Be among the first 40 applicants";
  else if (total < 50) return "Be among the first 50 applicants";
  else if (total < 100) return "Over 50 applicants";
  else if (total < 200) return "Over 100 applicants";
  else if (total < 300) return "Over 200 applicants";
  else if (total < 400) return "Over 300 applicants";
  else if (total < 500) return "Over 400 applicants";
  else return "Over 500 applicants";
};

export const getTextWithIcon = (
  text: string | ReactElement,
  iconComponent: ReactElement,
  hideSalary: number | undefined = 0,
  category?: string | "",
  addDisc?: boolean,
) => {
  const textContent = () => {
    if (category === "location") {
      if (typeof text === "string")
        return text.split(",").map((item, index) => (
          <a
            href={`/search/jobs-in-${item
              .toLowerCase()
              .trim()
              .replace(/[^a-z]+/g, "-")}`}
            title={`Jobs in ${item.trim()}`}
            key={index}
          >
            {item}
            {index === text.split(",").length - 1 ? "" : ", "}
          </a>
        ));
    } else if (category === "industry") {
      if (typeof text === "string") {
        return (
          <div className="flex flex-wrap">
            {text.split(",").map((item, index) => (
              <p key={index} className="text-content-primary mr-1 text-sm">
                {item}
                {index === text.split(",").length - 1 ? "" : ", "}
              </p>
            ))}
          </div>
        );
      }
    } else {
      return <span>{text}</span>;
    }

    return "";
  };

  return (
    <div className="flex items-center gap-2">
      {addDisc && (
        <div className="bg-content-tertiary -mt-px size-[5px] rounded-full"></div>
      )}
      <span className="mt-[2px] self-start">{iconComponent}</span>
      {textContent()}
      {hideSalary === 2 && text !== "Confidential" ? (
        <span className="text-darkKnight-500 text-xs">(estd)</span>
      ) : null}
    </div>
  );
};
